const NothingToRead = () => {
  return (
    <svg
      width="161"
      height="150"
      viewBox="0 0 161 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M108.131 57.3423C96.8403 57.3423 85.3476 56.8837 74.5969 53.8891C64.0484 50.962 54.3633 45.2831 45.7303 38.714C40.0784 34.4379 34.939 31.0387 27.601 31.5513C20.4161 31.9446 13.5486 34.6405 8.0149 39.24C-1.31952 47.3335 0.0833362 62.4817 3.8198 73.1245C9.43125 89.1495 26.5084 100.251 41.0226 107.508C57.7895 115.885 76.2155 120.741 94.6821 123.547C110.869 126.002 131.669 127.796 145.698 117.22C158.58 107.508 162.114 85.3321 158.957 70.3593C158.192 65.932 155.837 61.9364 152.334 59.1229C143.283 52.5133 129.781 56.9242 119.61 57.1535C115.833 57.2344 111.989 57.3288 108.131 57.3423Z"
        fill="#DDEFFD"
      />
      <path
        d="M80.5044 149.772C107.853 149.772 130.023 148.389 130.023 146.683C130.023 144.977 107.853 143.594 80.5044 143.594C53.1562 143.594 30.9861 144.977 30.9861 146.683C30.9861 148.389 53.1562 149.772 80.5044 149.772Z"
        fill="#99CFF8"
      />
      <path
        d="M131.102 40.8594V46.6732"
        stroke="#0B4EDB"
        strokeWidth="1.34891"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M128.202 43.7656H134.002"
        stroke="#0B4EDB"
        strokeWidth="1.34891"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.6838 89.7109V95.5112"
        stroke="#0B4EDB"
        strokeWidth="1.34891"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.7708 92.6094H36.5845"
        stroke="#0B4EDB"
        strokeWidth="1.34891"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.5503 16.6797V22.48"
        stroke="#0B4EDB"
        strokeWidth="1.34891"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.637 19.5781H28.4507"
        stroke="#0B4EDB"
        strokeWidth="1.34891"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M88.7604 3.22198C89.4905 3.22198 90.0823 2.63013 90.0823 1.90005C90.0823 1.16997 89.4905 0.578125 88.7604 0.578125C88.0303 0.578125 87.4385 1.16997 87.4385 1.90005C87.4385 2.63013 88.0303 3.22198 88.7604 3.22198Z"
        fill="#0B4EDB"
      />
      <path
        d="M85.6037 132.167C86.3337 132.167 86.9256 131.575 86.9256 130.845C86.9256 130.115 86.3337 129.523 85.6037 129.523C84.8736 129.523 84.2817 130.115 84.2817 130.845C84.2817 131.575 84.8736 132.167 85.6037 132.167Z"
        fill="#0B4EDB"
      />
      <path
        d="M113.992 9.53038L37.0599 17.5213C35.3038 17.7037 34.028 19.2752 34.2104 21.0314L44.7321 122.329C44.9145 124.085 46.486 125.361 48.2422 125.178L125.174 117.187C126.931 117.005 128.206 115.433 128.024 113.677L117.502 12.3799C117.32 10.6237 115.748 9.34797 113.992 9.53038Z"
        fill="#BAAAE9"
      />
      <path
        d="M110.681 14.2L41.2489 21.4119C39.4927 21.5943 38.217 23.1658 38.3994 24.922L47.9149 116.532C48.0973 118.289 49.6688 119.564 51.425 119.382L120.857 112.17C122.613 111.988 123.889 110.416 123.707 108.66L114.191 17.0495C114.009 15.2934 112.437 14.0176 110.681 14.2Z"
        fill="white"
        stroke="#522AC7"
        strokeWidth="1.34891"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M98.7015 18.6944L97.6224 8.30782C97.5683 7.87671 97.3472 7.48403 97.0067 7.21415C96.6662 6.94427 96.2334 6.81872 95.8013 6.86449L82.9598 8.2134C82.8552 7.17712 82.5476 6.17158 82.0545 5.25419C81.5614 4.33679 80.8924 3.52551 80.0858 2.86665C79.2791 2.2078 78.3506 1.71428 77.3532 1.41427C76.3558 1.11426 75.3091 1.01364 74.2728 1.11816C73.2365 1.22267 72.231 1.53027 71.3136 2.02339C70.3962 2.51651 69.5849 3.1855 68.9261 3.99216C67.5954 5.62128 66.9665 7.71226 67.1776 9.80511L54.2955 11.154C54.0784 11.1759 53.8678 11.2404 53.6757 11.3439C53.4836 11.4473 53.3137 11.5876 53.1759 11.7567C53.0381 11.9259 52.935 12.1206 52.8725 12.3296C52.81 12.5387 52.7893 12.758 52.8117 12.975L53.8909 23.3616C53.9128 23.5787 53.9773 23.7893 54.0807 23.9815C54.1841 24.1736 54.3244 24.3434 54.4936 24.4812C54.6627 24.6191 54.8574 24.7222 55.0665 24.7847C55.2755 24.8471 55.4948 24.8678 55.7119 24.8454L97.2312 20.5289C97.449 20.5071 97.6604 20.4421 97.8528 20.3377C98.0452 20.2332 98.2149 20.0914 98.3518 19.9206C98.4887 19.7497 98.5902 19.5533 98.6502 19.3427C98.7103 19.1322 98.7277 18.9118 98.7015 18.6944Z"
        fill="white"
        stroke="#522AC7"
        strokeWidth="1.34891"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NothingToRead;
